import "pixi.js";

import ProjectileLogic from "./ProjectileLogic";
import FlierLogic from "./FlierLogic";


class FakeProjectileLogic extends ProjectileLogic
{


    constructor(botId = null, parentProjectileLogic)
    {
        super(botId);
        this.parentProjectileLogic = parentProjectileLogic;
        this.isFake = true; // TODO remove flag, used only for tests
    }


    getReticleOffsetPosition()
    {
        let targetPos = this.target.position.clone();

        let projPos;
        if (!this.parentProjectileLogic.autoLock && !this.botId && this.parentProjectileLogic.targetHit) {
            let mv = this.entitySystem.mainView;
            let c = mv.mainContainer;

            if (!this.reticlePos)
            {
                this.reticlePos = c.toLocal(mv.reticleGlobalPos).clone();
            }
            let reticleProjOnTarget = this.app.layout.projectScreenToGame3D(this.reticlePos, this.target.position.z - 1);

            projPos = reticleProjOnTarget.subtract(targetPos);
            if (projPos.getLength() > this.target.collisionRadius) {
                projPos.normalize();
                projPos.scale(this.target.collisionRadius);
            }
            projPos = projPos.add(this.target.position);
        }
        else {
            projPos = targetPos;
        }

        return projPos;
    }



    initialAcquireTarget()
    {
        this.target = this.parentProjectileLogic.getTarget();
    }


    acquireTarget()
    {
        this.target = this.parentProjectileLogic.getTarget();
    }


    postPhysicsUpdate(delta)
    {
        this.lifeTime += delta;

        this.acquireTarget();

        if (!this.parentProjectileLogic.active)
        {
            this.getEntity().queueForRemoval = true;
        }
        else
        {
            if (this.target)
            {
                if (this.parentProjectileLogic.targetHit == true)
                {
                    this.setVelocityTowardsTarget();
                }
                this.timeBeforeAutoTarget = this.parentProjectileLogic.timeBeforeAutoTarget;
                this.updateVelocity(delta);
            }
        }

        this.setProjectileRotation();

        this.moveSplashInFront();
    }


}


export default FakeProjectileLogic;